import { render, staticRenderFns } from "./consultaporcodigo.vue?vue&type=template&id=72aa314f&scoped=true"
import script from "./consultaporcodigo.vue?vue&type=script&lang=js"
export * from "./consultaporcodigo.vue?vue&type=script&lang=js"
import style0 from "./consultaporcodigo.vue?vue&type=style&index=0&id=72aa314f&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72aa314f",
  null
  
)

export default component.exports